/* eslint-disable react/prop-types */
import React from 'react';

// import {useHistory} from 'react-router-dom';
import EmptyState from '../../../../../../../../components/shared/EmptyState';
import {ViewCurriculumMainContainer} from './elements';
import {Module} from './components';
import {TableSpinner} from '../../../../../../components-new';

export const ViewCurriculumMain = ({
  moduleData,
  courseName,
  courseId,
  resetOffset,
  offset,
  isListLoading,
}) => (
  <ViewCurriculumMainContainer>
    {moduleData &&
      !isListLoading &&
      moduleData?.map((item, index) => (
        <Module
          resetOffset={resetOffset}
          item={item}
          courseName={courseName}
          position={offset + index + 1}
          courseId={courseId}
          moduleId={item?.ocrm_id_course_curriculum_module}
          key={item?.ocrm_id_course_curriculum_module}
        />
      ))}
    {isListLoading ? <TableSpinner /> : null}
    {!moduleData.length && !isListLoading ? (
      <EmptyState
        body="There is no data about uploaded files and modules available."
        title="No Data Found"
      />
    ) : null}
  </ViewCurriculumMainContainer>
);
